module.exports = __webpack_public_path__ + "static/img/riby.73f6936.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/riby.png
// module id = uiWM
// module chunks = 0